import { Card, styled } from '@mui/material';

export const DashboardCard = styled(Card)({
  maxWidth: 345,
  background: 'none',
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  boxShadow: 'none',
});
